var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-flex"},_vm._l((_vm.boxes),function(v,i){return _c('div',{key:i,staticClass:"box pulse"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }